export function classNames(...classes: (false | null | undefined | string)[]) {
	return classes.filter(Boolean).join(' ');
}

export const NVL = (value: boolean | undefined, property: string, def = '', prefix = '') => {
	return value ? prefix + property : def;
};
